import { render } from "./index.vue?vue&type=template&id=36025478"
const script = {}
script.render = render

export default script